import box from '~/assets/icons/box_4.svg';
import contract from '~/assets/icons/contract.svg';
import group from '~/assets/icons/group_2.svg';
import rank from '~/assets/icons/rank.svg';
// import truck from '~/assets/icons/truck_2.svg';

export enum AppTruckJobMenu {
	ALL_ORDERS = 'all_orders',
	MY_CONTRACTS = 'my_contracts',
	PROGRESS = 'progress',
	// GARAGE = 'garage',
	GROUP = 'group',
}

export const appTruckJobButtons = {
	[AppTruckJobMenu.ALL_ORDERS]: {
		name: 'Все заказы',
		icon: box,
	},
	[AppTruckJobMenu.MY_CONTRACTS]: {
		name: 'Мои контракты',
		icon: contract,
	},
	[AppTruckJobMenu.PROGRESS]: {
		name: 'Мой прогресс',
		icon: rank,
	},
	// [AppTruckJobMenu.GARAGE]: {
	// 	name: 'Мой гараж',
	// 	icon: truck,
	// },
	[AppTruckJobMenu.GROUP]: {
		name: 'Мой конвой',
		icon: group,
	},
};

export enum TruckJobRarity {
	COMMON = 'common',
	UNCOMMON = 'uncommon',
	RARE = 'rare',
	EPIC = 'epic',
	LEGENDARY = 'legendary',
}
